import { render, staticRenderFns } from "./shfx.vue?vue&type=template&id=3fdf3e40&scoped=true&"
import script from "./shfx.vue?vue&type=script&lang=js&"
export * from "./shfx.vue?vue&type=script&lang=js&"
import style0 from "./shfx.vue?vue&type=style&index=0&id=3fdf3e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf3e40",
  null
  
)

export default component.exports